import PARENT from '../types.js';

const DATASET = `${PARENT}/DATASET`;

export const SET_DATASET = `${DATASET}/SET_DATA`;
export const SET_FREQUENCY_DATASET = `${DATASET}/SET_FREQUENCY_DATASET`;

export const SET_NAME_OF_DATASET = `${DATASET}/SET_NAME_OF_DATASET`;
export const SET_TYPE_OF_DATASET = `${DATASET}/SET_TYPE_OF_DATASET`;
export const SET_CORRECT_VAR_TYPES = `${DATASET}/SET_CORRECT_VAR_TYPES`;
export const SET_NAME_OF_COLUMNS = `${DATASET}/SET_NAME_OF_COLUMNS`;

export const RESET_DATASET = `${DATASET}/RESET_DATASET`;
export const RESET_FREQUENCY_DATASET = `${DATASET}/RESET_FREQUENCY_DATASET`;
